var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeList " },
    [
      _c("Search", {
        attrs: { placeholder: "活动名称/地点/门店" },
        on: { typesChange: _vm.typesChange }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.finished,
                "finished-text": "没有更多了",
                "immediate-check": false
              },
              on: { load: _vm.getList },
              model: {
                value: _vm.loading,
                callback: function($$v) {
                  _vm.loading = $$v
                },
                expression: "loading"
              }
            },
            [
              _vm._l(_vm.list, function(item) {
                return [_c("Card", { attrs: { item: item } })]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loaded" }, [
        _vm._v("已加载 " + _vm._s(_vm.list.length) + "/" + _vm._s(_vm.total))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.hasAddAuth ? "orientation-bottom" : "orientation-bottom-1"
        },
        [
          _c(
            "div",
            {
              staticClass: "homePage",
              on: {
                click: function($event) {
                  return _vm.$router.push("/")
                }
              }
            },
            [
              _c("img", {
                staticClass: "homePageImg",
                attrs: { src: require("@/assets/img/homePage.png"), alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _vm.hasAddAuth
            ? _c("div", { staticClass: "add", on: { click: _vm.toApply } }, [
                _c("img", {
                  staticClass: "addImg",
                  attrs: { src: require("@/assets/img/add.png"), alt: "" }
                })
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7234e58a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7234e58a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/reportList.vue
// module id = null
// module chunks = 